// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"0765684f","982":"55b28085"}[chunkId] + ".chunk.css";
};